import dayjs from "dayjs";

export const formatDate = function (
  modifiedDate,
  format = "MMM DD, YYYY, hh:mm A"
) {
  return dayjs(modifiedDate).format(format);
};

export const getOriginalTime = function (timeInMinutes, pauseUnit) {
  let originalTime;
  if (pauseUnit === 3) {
    originalTime = timeInMinutes / 1440;
  } else if (pauseUnit === 2) {
    originalTime = timeInMinutes / 60;
  } else {
    originalTime = timeInMinutes;
  }
  return originalTime;
};

export const getTriggerEvents = function (filterEvents = []) {
  const triggerEvents = {
    campaign_sent: {
      event: "Campaign sent",
      description: "Activates when a campaign is sent.",
      value: "campaign_sent",
    },
    campaign_opened: {
      event: "Campaign opened",
      description: "Initiates when a recipient opens your campaign.",
      value: "campaign_opened",
    },
    campaign_clicked: {
      event: "Campaign clicked",
      description: "Activates when a recipient interacts with your campaign.",
      value: "campaign_clicked",
    },
    campaign_error: {
      event: "Campaign error",
      description: "Initiates when an error occurs in your campaign process.",
      value: "campaign_error",
    },
    spam: {
      event: "Spam",
      description:
        "Activates when a campaign is marked as spam by the recipient.",
      value: "spam",
    },
    hard_bounce: {
      event: "Hard bounce",
      description:
        "Initiates when your email is returned due to a permanent failure.",
      value: "hard_bounce",
    },
    // soft_bounce: {
    //   event: "Soft Bounce",
    //   description:
    //     "Initiates when your email is returned due to a temporary failure.",
    //   value: "soft_bounce",
    // },
    unsubscribe: {
      event: "Unsubscribe",
      description: "Activates when a recipient opts out of your campaign.",
      value: "unsubscribe",
    },
  };
  if (
    !filterEvents ||
    !Array.isArray(filterEvents) ||
    filterEvents.length === 0
  ) {
    return Object.values(triggerEvents);
  } else {
    const filteredEvents = filterEvents.reduce((acc, key) => {
      acc[key] = triggerEvents[key];
      return acc;
    }, {});
    return filteredEvents;
  }
};

export const getTriggerSources = function (filterSources = []) {
  const eventSources = {
    adminuser: { label: "Via Account user", value: "adminuser" },
    webform: { label: "Webform", value: "webform" },
    api: { label: "API/Integration", value: "api" },
  };
  if (
    !filterSources ||
    !Array.isArray(filterSources) ||
    filterSources.length === 0
  ) {
    return Object.values(eventSources);
  } else {
    const filteredSources = filterSources.reduce((acc, key) => {
      acc[key] = eventSources[key];
      return acc;
    }, {});
    return filteredSources;
  }
};
export const removeHubspot = function () {
  localStorage.removeItem("hub_user");
  localStorage.removeItem("mainUser");
  if (window.HubSpotConversations) {
    window.HubSpotConversations.widget.remove();
  }
};

export const getChatbotUserStatus = function () {
  var hubUser = localStorage.getItem("hub_user")
    ? localStorage.getItem("hub_user")
    : "";
  var mainUser = localStorage.getItem("mainUser")
    ? localStorage.getItem("mainUser")
    : "";
  if (hubUser && mainUser && parseInt(localStorage.getItem("isAdmin")) === 0) {
    return true;
  } else {
    return false;
  }
};

export const getWelcomeDashCurrentClass = function (welcomeDashboardItems) {
  var completed = "";
  const items = ["addCampaign", "addSenderId", "addDomain", "addContact"];
  items.forEach(function (element) {
    if (welcomeDashboardItems[element] === 0) {
      completed = element;
      return completed;
    }
  });
  return completed;
};

export const goToPage = function (vm, module, welcomeDashboardItems) {
  var path = "";
  switch (module) {
    case "contact":
      if (welcomeDashboardItems.addContact !== 2) {
        path = "recipients";
      }
      break;
    case "domain":
      if (welcomeDashboardItems.addDomain !== 2) {
        path = "account/domains";
      }
      break;
    case "senderId":
      if (
        welcomeDashboardItems.addSenderId !== 2 &&
        (welcomeDashboardItems.addDomain === 2 ||
          welcomeDashboardItems.addSenderId !== 0)
      ) {
        path = "account/sender-management";
      }
      break;
    case "campaign":
      if (
        welcomeDashboardItems.addSenderId === 2 ||
        welcomeDashboardItems.addCampaign !== 0
      ) {
        path = welcomeDashboardItems.campPage
          ? welcomeDashboardItems.campPage
          : "campaign";
      }
      break;
    default:
  }
  if (path !== "" && vm.$route.path !== "/" + path) {
    vm.$router.push({ path: "/" + path });
  }
};

export const getStepDisable = function (module, welcomeDashboardItems) {
  var disableVal = false;
  switch (module) {
    case "senderId":
      if (
        welcomeDashboardItems.addDomain !== 2 &&
        welcomeDashboardItems.addSenderId === 0
      ) {
        disableVal = true;
      }
      break;
    case "campaign":
      if (
        welcomeDashboardItems.addSenderId !== 2 &&
        welcomeDashboardItems.addCampaign === 0
      ) {
        disableVal = true;
      }
      break;
    default:
  }
  return disableVal;
};

export const resetLoginJwt = function (token, isPassword = false) {
  var user = JSON.parse(window.localStorage.getItem("login_data"));
  if (user) {
    user.token = token;
    if (!isPassword) {
      user.is_approve = 1;
      window.localStorage.setItem("is_approve", 1);
    }
    window.localStorage.setItem("login_data", JSON.stringify(user));
  }
};
